import http from "../requestBase";
import "../types/typdefs";

const API_BASE = "api/ProjectWaves";

/**
 * Update project wave
 * @param {string} guid
 * @param {*} content
 * @returns
 */
function updateProjectWave(guid, content) {
  return http.put(`${API_BASE}/${guid}`, content);
}

function deleteWave(guid) {
  return http.delete(`${API_BASE}/${guid}`);
}

function getWaveStatus(guid) {
  return http.get(`${API_BASE}/${guid}/Status`);
}

/**
 * Read project waves belonging to the survey
 * @param {number} id - the survey id
 * @returns
 */
function getBySurveyId(id) {
  return http.get(`${API_BASE}/SurveyId/${id}`);
}

/**
 * All API
 */
let UseProjectWaves = {
  updateProjectWave,
  deleteWave,
  getWaveStatus,
  getBySurveyId,
};

export default UseProjectWaves;



// WEBPACK FOOTER //
// ./src/services/ProjectWaves/index.js